import React from 'react';
import { Button, Table, Loader, Form, Input, Select, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema implementacija odabranog studijskog programa.</p>;


export default class ActiveSPImpl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            changeStatus: false,
            deleteImplementation: false,
            SPStatus: null,
            statusErr: false
        };
        this.setStatus = this.setStatus.bind(this);
        this.showDeleteConfirmation = this.showDeleteConfirmation.bind(this);
        this.deleteImplementation = this.deleteImplementation.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    setStatus(id, optlock) {
        if (!this.state.SPStatus) {
            this.setState({ statusErr: true });
            toast('Morate odabrati status.');
            return;
        }

        let archiveStudyProgram = {};

        if (id) archiveStudyProgram = { ...archiveStudyProgram, id };
        if (optlock) archiveStudyProgram = { ...archiveStudyProgram, optlock };
        if (this.state.SPStatus) archiveStudyProgram = { ...archiveStudyProgram, studyProgramStatusId: this.state.SPStatus };

        axios.put('study-programs/set-status', { ...archiveStudyProgram })
            .then(res => {
                this.setState({ statusErr: false, SPStatus: null, changeStatus: false });
                this.props.getImplemenations();
                toast('Status studijskog programa je uspješno promijenjen.');
            })
            .catch(err => {
                console.log('err.response.data', err.response.data);
                if (err.response.data === 'Study program is already changed') { toast('Status studijskog programa je već promijenjen.'); } else if (err.response.data === 'Could not set study program status.') { toast('Došlo je do grešek. Status studijskog programa nije promijenjen.'); } else toast('Studijski program već ima odabrani status!');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    showDeleteConfirmation(index) {
        this.setState({ deleteImplementation: index, changeStatus: false, SPStatus: null, statusErr: false });
    }

    deleteImplementation(implementation) {
        if (!implementation || !implementation.studyProgram || !implementation.studyProgram.id) return;

        axios.delete(`study-programs/delete-implementation/${implementation.studyProgram.id}`)
            .then(() => {
                this.setState({ deleteImplementation: false });
                toast('Implementacija je uspješno obrisana.');
                this.props.getImplemenations();
            })
            .catch(err => {
                let msg = 'Došlo je do greške. Implementacija nije obrisana.';
                if (err.response && err.response.data) {
                    msg = err.response.data;
                }
                this.setState({ deleteImplementation: false });
                toast(msg);
            });
    }


    render() {
        const { data } = this.props;
        if (!this.props.loaded) return (<div style={{ paddingTop: '50px' }}><Loader active inline="centered" /><br /></div>);
        return (
            <div>
                {data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">
                                    R. br.
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Odsjek
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    Naziv implementacije
                                </Table.HeaderCell>
                                <Table.HeaderCell width="3">
                                    Napomena
                                </Table.HeaderCell>
                                <Table.HeaderCell width="3" />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {data.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle" width={1}>
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.departments.map(e => (<div>{e.name}<br /></div>))}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.studyProgram.name}
                                </Table.Cell>
                                <Table.Cell width="3" verticalAlign="middle">
                                    {el.studyProgram.description}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" width="3">
                                    { this.state.deleteImplementation === index ?
                                        <div>
                                            <Popup
                                                content="Potvrdi brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="check"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => this.deleteImplementation(el)}
                                                    />
                                                }
                                            />
                                            <Popup
                                                content="Odustani"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="delete"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.setState({ deleteImplementation: false })}
                                                    />
                                                }
                                            />
                                        </div>
                                        : this.state.changeStatus === index ?
                                        <div>
                                            <Form noValidate>
                                                <Form.Field
                                                    required
                                                    error={this.state.statusErr}
                                                    control={Select}
                                                    clearable
                                                    value={this.state.SPStatuse}
                                                    onChange={this.handleInputChange}
                                                    name="SPStatus"
                                                    options={this.props.SPStatuses}
                                                    search
                                                    fluid
                                                    placeholder="Odaberite status"

                                                />
                                                {/* <Button.Group> */}
                                                <Popup
                                                    content="Potvrdi"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="check"
                                                            size="small"
                                                            color="blue"
                                                            onClick={() => { this.setStatus(el.studyProgram.id, el.studyProgram.optLock); }}
                                                        ></Button>}
                                                >
                                                </Popup>
                                                <Popup
                                                    content="Odustani"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="delete"
                                                            size="small"
                                                            color="red"
                                                            onClick={() => { this.setState({ changeStatus: false, deleteImplementation: false, SPStatus: null, statusErr: false }); }}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                                {/* </Button.Group> */}
                                            </Form>
                                        </div>
                                        : <div>
                                            <Link to={{ pathname: '/osnovni-studijski-programi/implementacije/izmjena-i-detalji', state: { implementation: el, studyCycles: this.props.studyCycles } }}>
                                                <Popup
                                                    content={(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') ? 'Osnovni podaci / izmjena' : 'Detalji'}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            circular
                                                            icon={(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') ? 'pencil alternative' : 'list'}
                                                            basic="true"
                                                            color="green"
                                                            onClick={() => localStorage.setItem('implementation', JSON.stringify(el))}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>
                                            <Link to={{ pathname: '/osnovni-studijski-programi/implementacije/semestri', state: { implementation: el } }}>
                                                <Popup
                                                    content="Semestri"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            circular
                                                            icon="book"
                                                            basic="true"
                                                            color="blue"
                                                            onClick={() => localStorage.setItem('implementation', JSON.stringify(el))}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>
                                            {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Link to={{ pathname: '/osnovni-studijski-programi/implementacije/predmeti', state: { implementation: el } }}>
                                                <Popup
                                                    content="Predmeti"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            color="teal"
                                                            basic="true"
                                                            circular
                                                            size="small"
                                                            icon="list"
                                                            onClick={() => localStorage.setItem('implementation', JSON.stringify(el))}
                                                        >
                                                        </Button>}
                                                >
                                                </Popup>
                                            </Link>}
                                            {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Popup
                                                content="Promjena statusa"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        circular
                                                        icon="exchange"
                                                        basic="true"
                                                        color="yellow"
                                                        size="small"
                                                        onClick={() => { this.setState({ changeStatus: index, deleteImplementation: false }); }}
                                                    >
                                                    </Button>}
                                            >
                                            </Popup>}


                                            {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' &&
                                                localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && (
                                                <Popup
                                                    content="Kopiraj implementaciju"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            as={Link}
                                                            to={{
                                                                pathname: '/osnovni-studijski-programi/implementacije/kopiranje',
                                                                state: { implementation: el }
                                                            }}
                                                            circular
                                                            icon="copy outline"
                                                            basic
                                                            color="orange"
                                                            onClick={() => {
                                                                localStorage.setItem('implementation', JSON.stringify(el));
                                                                localStorage.setItem('basicName', el.studyProgram.studyProgramBasic ? el.studyProgram.studyProgramBasic.name : '');
                                                            }}
                                                        />
                                                    }
                                                />
                                            )}
                                            {(localStorage.getItem('activeRole').substr(0, 38) !== 'SluÅ¾ba za nastavu i studentska pitanja' &&
                                                localStorage.getItem('activeRole').substr(0, 30) !== 'SluÅ¾ba za osiguranje kvaliteta') && (
                                                <Popup
                                                    content="Obrisi implementaciju"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            circular
                                                            icon="trash"
                                                            basic
                                                            color="red"
                                                            onClick={() => this.showDeleteConfirmation(index)}
                                                        />
                                                    }
                                                />
                                            )}
                                        </div>
                                    }
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <NoDataMessage />
                }
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/ActiveSPImpl.js